import Vue from 'vue'
import store from '../store'
import injector from 'vue-inject'
Vue.use(injector)

const api = injector.get('api')

class Countries {
    fetchList() {
        Vue.http.get(api.countries.list)
            .then(response => {
                store.commit('setCountries', response.body)
            }, () => { })
    }
}

injector.service('countries', Countries);


// WEBPACK FOOTER //
// ./src/services/countries.js